import Form from './Form';
import Lta from './Lta';
import List from './List';
import Detail from './Detail';
import Fhl from './Fhl';
import Ffr from './Ffr';
import Csd from './Csd';

const Components = {
  Form,
  Lta,
  List,
  Detail,
  Fhl,
  Ffr,
  Csd
}

export default Components;